import { createCenterMapLink } from "../../helperFunctions.js";
import DataTable from "datatables.net-dt";

const HIDDEN_COLUMNS = new Set(["laengengrad", "breitengrad", "geokooridnaten"]);

let dtInstance = null;
let lokalenrRowMap = new Map();

function capitalize(text) {
  return text.charAt(0).toUpperCase() + text.slice(1);
}

const COLUMN_LABELS = {
  lokalenr:           "Lokale‑Nr.",
  baumart:            "Baumart",
  baumgattung:        "Baumgattung",
  baumsorte:          "Baumsorte",
  hoehe:              "Höhe",
  umfang:             "Stammumfang",
  kronendurchmesser:  "Kronendurchmesser",
  vitalitaet:         "Vitalität",
  pflanzjahr:         "Pflanzjahr",
  standort:           "Standort",
  standorttyp:        "Standorttyp",
  strasse:            "Straße",
  hausnummer:         "Hausnummer",
  hausnr:             "Hausnr.",
  pflegezustand:      "Pflegezustand",
  pflegemassnahme:    "Pflegemaßnahme",
  eigentuemer:        "Eigentümer",
  naechstekontrolle: "Nächste Kontrolle",
  koordinaten:        "Koordinaten",
};

function formatColumnHeader(col) {
  return COLUMN_LABELS[col.toLowerCase()] ?? capitalize(col);
}

export function renderTreeSearchDropdown(eigenschaften) {
  const select = document.getElementById("baumEigenschaft");
  select.innerHTML = "";
  const placeholder = document.createElement("option");
  placeholder.text = "Baumeigenschaft wählen";
  select.appendChild(placeholder);
  for (const eigenschaft of eigenschaften) {
    const option = document.createElement("option");
    option.value = eigenschaft.name;
    option.text = capitalize(eigenschaft.name);
    select.appendChild(option);
  }
}

export function renderLiveSearchResults(results) {
  const box = document.getElementById("livesearch");
  box.innerHTML =
    results.length === 0
      ? "Keine Ergebnisse gefunden"
      : results
          .map(([key, value]) => `<a href="#" class="livesearchLink">${key}</a> (${value})<br>`)
          .join("");
  box.style.removeProperty("display");
}

export function renderAreaLiveSearchResults(areas, countPerArea) {
  const anzahlEl = document.getElementById("anzahlGefundenerFlaechen");
  if (anzahlEl) anzahlEl.innerHTML = "Anzahl gefundener Bäume: " + areas.length;
  const box = document.getElementById("livesearchFlaechen");
  if (!box) return;
  box.innerHTML = areas
    .map((f) => `<a href="#" class="livesearchFlaechenLink">${f}</a> (${countPerArea[f]})<br>`)
    .join("");
  box.style.removeProperty("display");
}

export function renderSearchResultTable(features, col) {
  const count = features.length;
  document.getElementById("resultCount").innerHTML = "Anzahl angezeigter Bäume: " + count;
  document.getElementById("data-table-result-count").textContent = count + " Bäume";

  const visibleCols = col.filter(c => !HIDDEN_COLUMNS.has(c));

  if (dtInstance) {
    dtInstance.destroy();
    dtInstance = null;
  }

  const table = document.createElement("table");
  table.setAttribute("class", "table table-striped table-bordered table-sm w-100");
  table.setAttribute("id", "resultTable");

  const thead = document.createElement("thead");
  const headerRow = document.createElement("tr");
  for (const c of visibleCols) {
    const th = document.createElement("th");
    th.textContent = formatColumnHeader(c);
    th.setAttribute("scope", "col");
    headerRow.appendChild(th);
  }
  thead.appendChild(headerRow);
  table.appendChild(thead);

  const tbody = document.createElement("tbody");
  lokalenrRowMap = new Map();

  for (let i = 0; i < features.length; i++) {
    const feature = features[i];
    if (!feature?.bbox?.[1] || !feature?.bbox?.[0] || !feature?.geometry || !feature?.id) continue;
    const lat = feature.properties.breitengrad;
    const long = feature.properties.laengengrad;
    const tr = document.createElement("tr");
    for (const c of visibleCols) {
      const td = document.createElement("td");
      if (c === "Koordinaten") {
        td.append(createCenterMapLink("", lat, long));
      } else {
        td.textContent = feature.properties[c] ?? "";
      }
      tr.appendChild(td);
    }
    tbody.appendChild(tr);
    if (feature.properties.lokalenr != null) {
      lokalenrRowMap.set(String(feature.properties.lokalenr), { tr, dataIndex: i });
    }
  }

  table.appendChild(tbody);

  const divContainer = document.getElementById("data-table-content");
  divContainer.innerHTML = "";
  divContainer.appendChild(table);

  dtInstance = new DataTable("#resultTable", {
    paging: true,
    pageLength: 10,
    searching: true,
    ordering: true,
    scrollX: true,
    dom: "t<'dt-footer d-flex justify-content-between align-items-center pt-1'<''i><''p>>",
    language: {
      info: "_START_–_END_ von _TOTAL_ Bäumen",
      infoEmpty: "0 Bäume",
      paginate: { first: "«", last: "»", next: "›", previous: "‹" },
      zeroRecords: "Keine Ergebnisse gefunden",
    },
  });

  const dtSearchEl = document.getElementById("dt-search-input");
  const dtLengthEl = document.getElementById("dt-page-length");
  if (dtSearchEl) {
    dtSearchEl.value = "";
    dtSearchEl.oninput = () => dtInstance.search(dtSearchEl.value).draw();
  }
  if (dtLengthEl) {
    dtLengthEl.value = "10";
    dtLengthEl.onchange = () => dtInstance.page.len(parseInt(dtLengthEl.value)).draw();
  }
}

export function highlightTableRow(lokalenr) {
  if (!dtInstance) return;
  const entry = lokalenrRowMap.get(String(lokalenr));
  if (!entry) return;
  const allRows = dtInstance.rows({ order: "current" }).nodes().toArray();
  const pos = allRows.indexOf(entry.tr);
  if (pos === -1) return;
  const page = Math.floor(pos / dtInstance.page.len());
  dtInstance.page(page).draw(false);
  setTimeout(() => entry.tr.scrollIntoView({ behavior: "smooth", block: "center" }), 100);
}

export function renderCo2Badge(co2SaveSum) {
  document.getElementById("co2TonBadge").innerHTML = co2SaveSum.toFixed(2);
  document.getElementById("co2AlertBox").classList.remove("d-none");
}
